/**
 * 案件の任意入力項目の上限。API 側の Company::MAX_CUSTOM_INPUT_FIELDS と揃える
 * （超えると /api/v2/company が 400 を返す）。
 */
export const MAX_CUSTOM_INPUT_FIELDS = 20;

/** 入力欄を折り返す最大列数。20 件を 1 行に並べると 1 列 5% 幅になって読めない */
const MAX_COLUMNS = 4;

/**
 * 任意項目の入力欄を並べる列数。
 * 0 件のときも 1 を返す（grid-template-columns が `repeat(0, 1fr)` にならないように）。
 */
export const customInputFieldColumns = (count: number): number => Math.min(Math.max(count, 1), MAX_COLUMNS);

/**
 * 保存する任意項目のスロット。
 * 途中の空欄は index を保つため残し（詰めると後続スロットが繰り上がる）、
 * 末尾の空欄だけ落とす（名前を入れなかった追加分が延々と残らないように）。
 */
export const trimTrailingEmptySlots = (slots: string[]): string[] => {
  const lastFilled = slots.reduce((last, value, index) => (value ? index : last), -1);
  return slots.slice(0, lastFilled + 1);
};
